import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthConnectionService } from '../../shared/services/auth-connection.service';
import { Router } from '@angular/router';
import { TokenService } from '../../shared/services/token.service';
import { ApiService } from '@shared/services/api.service';



enum View {
  login = 'login',
  offices = 'offices'
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public formLogin!: FormGroup;
  public offices: any[] = [];
  public access_token!: string;
  public loginFailed: boolean = false;
  public currentView: string = View.login;
  public loginToken: any = null;
  public loginMe: any = null;
  public userOfficeId: any = null;

  constructor(
    private FormBuilder: FormBuilder,
    private authConnectionService: AuthConnectionService,
    private router: Router,
    private tokenService: TokenService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    if (localStorage.getItem('access_token')) {
      localStorage.removeItem('access_token');
    }
    if (localStorage.getItem('me')) {
      localStorage.removeItem('me');
    }
    this.formLogin = this.FormBuilder.group({
      employee_code: ['', [Validators.required]],
      password: ['', [Validators.required]],
      checkedRemember: [false],
    });
  }

  ngAfterViewInit() {

  }

  login() {
    if (!this.formLogin.invalid) {
      const credentials = {
        employee_code: this.formLogin.get('employee_code')?.value as number,
        password: this.formLogin.get('password')?.value as string,
        remember: this.formLogin.get('checkedRemember')?.value as boolean,
        is_app: false
      };

      this.authConnectionService.login(credentials).subscribe(
        (response: any) => {
          if (response.token) {
            this.loginToken = response.token;
            this.loginMe = response.me;
            this.userOfficeId = this.loginMe.office?.id || null;
            let hasOpenCashier = false;
            this.apiService.getOffices().subscribe({
              next: (offices) => {
                this.offices = offices;
                this.offices.forEach((office) => {
                  if (office.id == this.userOfficeId && office.has_open_cashier) {
                    hasOpenCashier = true;
                    console.log('office.has_open_cashier', office.has_open_cashier);
                    this.enterToSystem(office.id);
                  }
                });
                if (!hasOpenCashier) {
                  this.currentView = View.offices;
                }
              },
              error: (err) => console.error('Error fetching offices:', err)
            });
          } else {
            localStorage.removeItem('access_token');
            console.error('El servidor no proporcionó un token válido.');
          }
        },
        (error) => {
          console.error('Error de inicio de sesión', error);
          this.loginFailed = true;
          this.formLogin.reset();
        }
      );
    }
  }

  enterToSystem(officeId: number) {
    localStorage.setItem('access_token', this.loginToken);
    localStorage.setItem('me', JSON.stringify(this.loginMe));
    this.apiService.setOfficeToUser(officeId).subscribe({
      next: (response: any) => {
        console.log('Office set:', response);
        this.router.navigate(['/panel/dashboard']);
      }
    });
  }

}


